import $ from 'jquery';
export const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif'];
export const VIDEO_EXTENSIONS = ['mp4', 'avi'];
export const FIREFOX_MAX_SAFE_INT_V_43 = 99999999;
export const MAX_DATE = new Date(8640000000000000);
export const MIN_DATE = new Date(-8640000000000000);

export function formatNumber(
  numStr,
  separator = ' ',
  nullValue = '',
  floatSpearatorParse = '.',
  floatSpearatorDisplayed = ','
) {
  if (numStr == null || numStr == undefined || numStr === '') {
    return nullValue;
  }
  let max2Decimal =
    Math.round((parseFloat(numStr) + Number.EPSILON) * 100) / 100;
  var parts = (max2Decimal + '').toString().split(floatSpearatorParse);
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);

  return parts.join(floatSpearatorDisplayed);
}
export function safeGetProp(object, path) {
  const pathArray = path.split('.');
  return pathArray.reduce(function(xs, x) {
    return xs && xs[x] ? xs[x] : null;
  }, object);
}
export function timeout(ms) {
  return new Promise(res => setTimeout(res, ms));
}
export async function GetBase64UrlFromFile(file) {
  if (!file) {
    return null;
  }
  const reader = new FileReader();
  reader.readAsDataURL(file);

  return new Promise((resolve, reject) => {
    reader.onload = ev => {
      resolve(ev.target.result);
    };
    reader.onerror = e => {
      console.log(e);
      reject(e);
    };
    reader.onabort = e => {
      console.log(e);
      reject(e);
    };
  });
}
export async function scrollToPos(el, { top = 0, duration = 250 } = {}) {
  let $el = $(el);
  if ($el.length == 0) {
    return;
  }

  $el.animate({ scrollTop: top }, duration);
  await timeout(duration);
}

export function GetParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
export function getMaxPages(max, perPage) {
  return Math.ceil(max / perPage);
}
export function getMinMaxPagination(page, collectionLength, perPage) {
  let min = (page - 1) * perPage;
  let max = Math.min(collectionLength, min + perPage);
  return { min, max };
}
export function isInViewport(element) {
  if (!element) {
    return false;
  }
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
export function isLocalStorageEnabled() {
  try {
    let teszt = localStorage.getItem('teszt');
    return true;
  } catch (error) {
    console.log('Localstorage nem használható', error);
  }
  return false;
}
export function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
export function isDarkColor(color) {
  let hex = color.replace('#', '');
  let r = parseInt(hex.substr(0, 2), 16);
  let g = parseInt(hex.substr(2, 2), 16);
  let b = parseInt(hex.substr(4, 2), 16);
  let brightness = (r * 299 + g * 587 + b * 114) / 1000;

  if (brightness <= 180) {
    return true;
  } else {
    return false;
  }
}
